import React, { useState, useEffect } from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import Icon from '../../../../components/atoms/Icon'
import icons from '../../../../_constants/icons'
import text from '../../../../_constants/text'
import SingleLineTextInputField from '../../../../components/forms/fields/SingleLineTextInputField'
import { connect } from 'react-redux'
import { removePractice } from '../../../../actions/RemovePractice/removePracticeActions'
import AlertBox from '../../../../components/molecules/AlertBox'

interface RemovePracticeModalProps {
  show: boolean
  handleShow: () => void
  removePractice: (providerNumber: string, practiceName: string) => void
  submit: { inProgress: boolean; success: boolean; fail: boolean; error?: string | null }
}

const RemovePracticeModal: React.FC<RemovePracticeModalProps> = ({ show, handleShow, removePractice, submit }) => {
  const [practiceName, setPracticeName] = useState('')
  const [providerNumber, setProviderNumber] = useState('')
  const [showErrors, setShowErrors] = useState(false)

  useEffect(() => {
    if (!show) {
      setPracticeName('')
      setProviderNumber('')
      setShowErrors(false)
    }
  }, [show])

  useEffect(() => {
    if (show && !submit.inProgress && !submit.fail && (practiceName || providerNumber)) {
      setPracticeName('')
      setProviderNumber('')
      setShowErrors(false)
      handleShow()
    }
  }, [submit.fail])

  const handleRemove = () => {
    setShowErrors(true)
    if (!practiceName || !providerNumber) return
    removePractice(providerNumber, practiceName)
  }

  return (
    <Modal show={show} onHide={handleShow} centered size="lg" data-testid="RemovePracticeModal">
      <Modal.Body className="p-4">
        <div className="d-flex flex-row justify-content-between mb-1">
          <h2 className="mt-4">{text.REMOVE_PRACTICE_HEADER}</h2>
          <div className="c-pointer" onClick={handleShow} data-testid="RemovePracticeModal-Close">
            <Icon name={icons.CLOSE} />
            <p className="blue bold">{text.CLOSE}</p>
          </div>
        </div>
        {submit.fail && submit.error && <AlertBox type="error" message={submit.error} />}
        <form>
          <Row>
            <Col xs={12} lg={6}>
              <SingleLineTextInputField
                label={text.PROVIDER_NUMBER}
                type="text"
                inputName="providerNumber"
                required={false}
                value={providerNumber}
                onChangeCb={(_, value) => setProviderNumber(value || '')}
                error={showErrors && !providerNumber}
                errorMessage="This field is required"
                placeholder={text.PRACTICE_NUMBER_PLACEHOLDER}
              />
            </Col>
            <Col xs={12} lg={6}>
              <SingleLineTextInputField
                label={text.PRACTICE_NAME}
                type="text"
                inputName="practiceName"
                required={false}
                value={practiceName}
                onChangeCb={(_, value) => setPracticeName(value || '')}
                error={showErrors && !practiceName}
                errorMessage="This field is required"
                placeholder={text.PRACTICE_NAME_PLACEHOLDER}
              />
            </Col>
          </Row>
          <Row>
            <Col className="d-flex flex-row justify-content-end">
              <Button variant="light" className="mx-3" onClick={handleShow}>
                {text.CANCEL}
              </Button>
              <Button onClick={handleRemove} disabled={!practiceName || !providerNumber}>
                {text.REMOVE_PRACTICE}
              </Button>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  submit: state.removePractice.submit,
})

const mapDispatchToProps = (dispatch) => ({
  removePractice: (providerNumber: string, practiceName: string) =>
    dispatch(removePractice(providerNumber, practiceName)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RemovePracticeModal)
